module.exports = __webpack_public_path__ + "static/media/review-carousel.fa9ba06d.png";